var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invocation-time",attrs:{"invocation_id":_vm.args.invocation_id}},[_c('pre',[_c('code',[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }